export default __webpack_public_path__ + "static/media/sync.eb4f1c2b.svg";